import {createAction, props} from "@ngrx/store";
import {DosageUom, DoseEntity, DoseType, Prescription, PrescriptionDetailed} from "fitmed-models";

export interface UpdateDose {
  id: string | null;
  prescriptionId: string;
  type: DoseType;
  value: string | null;
  uom: DosageUom;
}

const TAG = '[Prescription-Detail]'

export const setPrescriptions = createAction(`${TAG} Set Prescriptions`, props<{ prescriptions: Prescription[] }>());
// Start new doses
export const loadDoses = createAction(`${TAG} Load Doses`, props<{ prescriptions: string[], assigning: boolean }>());
export const loadDosesSuccess = createAction(`${TAG} Load Doses Success`, props<{ doses: DoseEntity[], prescriptions: string[] }>());
export const loadDosesFailure = createAction(`${TAG} Load Doses Failure`, props<{ error: any, prescriptions: string[] }>());

export const updateDose = createAction(`${TAG} Update Dose`, props<{ update: UpdateDose, assigning: boolean }>());
export const updateDoseSuccess = createAction(`${TAG} Update Dose Success`, props<{ dose: DoseEntity }>());
export const updateDoseFailure = createAction(`${TAG} Update Dose Failure`, props<{ error: any, update: UpdateDose }>());

export const resetPrescriptionDetailState = createAction(`${TAG} Reset State`);
